import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "skill-items-preview" }
const _hoisted_2 = { class: "skill-preview" }

import { computed } from 'vue'
import Question from '../models/Question'
import { IQuestionSkill } from '../types'


export default /*@__PURE__*/_defineComponent({
  __name: 'SkillPreviewComponent',
  props: {
    question: {}
  },
  setup(__props: any) {

const props = __props

const skills = computed<IQuestionSkill>(() => {
  return props.question.skills
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skills.value, (skillItems, skill) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "skill-items-list",
        key: skill
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(skill), 1 /* TEXT */),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skillItems, (skillItem, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "skill-item-preview ms-2",
            key: index
          }, [
            (skillItem.name != 'prompt_ref')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(skillItem.name), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})